export function validateAddress(value) {
    const length = value.length;
    if( length < 1 ) {
        return {
            value: value,
            isValid : false,
            message : "Error: Please enter an Address."
        }
    }
    else if (length > 100) {
        return {
            value: value,
            isValid : false,
            message : "Error: Address cannot exceed 100 characters in length."
        }
    }
    else if (length >= 1 && length <= 100) {
        // const LIMITED_TEXT_PATTERN = /^([\w-\.](\s)?)*$/; // Unnecessary escape character: \.
        const LIMITED_TEXT_PATTERN = /^([\w-.](\s)?)*$/;
        let matches = LIMITED_TEXT_PATTERN.test(value);
        if(!matches) {
            return {
                value: value,
                isValid : false,
                message : "Error: Please enter alphanumeric characters in English only. Use only spaces, hyphens, period, and underscores (no commas). Enter no more than one space between characters."
            }
        } else {
            return {
                value: value,
                isValid : true,
                message : ""
            }
        }
    }
}

export default validateAddress;


// WEBPACK FOOTER //
// ./src/helper/validateAddress.js